import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30bc05ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary" }

import { storeToRefs } from 'pinia';
import { useModal } from '@/store';
import { PromoList, PromoInput, PromoTotalPrices, PromoCommonInfo } from '@/components/cart/promo/_index';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartSummary',
  setup(__props) {

const { modalIsShow } = storeToRefs(useModal());

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
    class: "summary-form"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PromoTotalPrices)),
      _createVNode(_unref(PromoList)),
      _createVNode(_unref(PromoCommonInfo)),
      _createVNode(_unref(PromoInput)),
      _createVNode(_component_AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (modalIsShow.value = true)),
        class: "summary__buy"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Buy now")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 32 /* HYDRATE_EVENTS */))
}
}

})